<template>

  <div>
    <div uk-grid class="uk-grid uk-child-width-expand@s">

      <div>
        <div class="uk-form-control uk-form-control-large">
          <span class="uk-form-icon uk-form-icon-flip" uk-icon="search"></span>
          <input type="search" :placeholder="sfModel.BackgroundHint" class="uk-input uk-box-shadow-medium" v-model="searchQuery" @change="filterChange" aria-autocomplete="both"/>
        </div>
      </div>

      <div>
        <input-checkboxes
            class="uk-form-control uk-form-control-large"
            v-model="selectedCategories"
            :key="selectedCategories"
            @change="filterChange"
            :options="categories"
            :optionLabelKey="optionLabelKey"
            :optionChildrenKey="optionChildrenKey"
            :label="l('Category')"
            name="categories"
        />
      </div>


      <div>
        <input-checkboxes
            class="uk-form-control uk-form-control-large"
            v-model="selectedContentTypes"
            :key="selectedContentTypes"
            @change="filterChange"
            :options="contentTypes"
            :optionLabelKey="optionLabelKey"
            :optionChildrenKey="optionChildrenKey"
            :label="l('ContentType')"
            name="categories"
        />
      </div>

      <div style="flex-basis: min-content;flex-grow: 0;">
        <button style="border-radius: 30px; line-height: 60px" type="button" class="uk-button  uk-button-primary   uk-button-large uk-width-auto@s uk-width-1-1 " @click="filterChange"><span>{{l('Search')}}</span><span uk-icon="search" class="uk-icon"></span></button>
      </div>

    </div>
  </div>

</template>
<script setup>
import {onMounted, ref} from 'vue'
import InputCheckboxes from "./input-checkboxes.vue";
import {sfUtil} from "../../util";

const props = defineProps({
  sfModel: Object,
  taxonomies: Object,
  additionalFilters: Object
})

const l = window.l

let additionalFilters = {...props.additionalFilters}

let taxonomies = {...props.taxonomies}
let categories = taxonomies['categories']
let contentTypes = []

Object.keys(taxonomies['contentTypes']).forEach(k => {
  let item = taxonomies['contentTypes'][k]
  contentTypes.push({...item, 'Title': l(item['Title']), 'Name': k})
})

let searchQuery = ref('')
let selectedCategories = ref(new Set());
let selectedContentTypes = ref(new Set());
let initialResultsHtml = null


const CONTENT_TYPE = 'ContentType'
const CATEGORIES = 'Categories'


const {
  optionLabelKey,
  optionValueKey,
  optionChildrenKey,
  getSearchParams,
  filterChildren,
  objectByValueKeys,
  findSearchResultsContainer
} = sfUtil.useBaseSearch();

const searchResultsContainer = findSearchResultsContainer()

onMounted(() => {
  window.addEventListener('popstate', () => {
    updateSearchResults()
  })

  if (searchResultsContainer && !sfUtil.hasActiveFiltering()) {
    initialResultsHtml = searchResultsContainer.innerHTML
  }
})

let initFilterState = () => {
  let searchParams = getSearchParams()
  searchQuery.value = searchParams.get('searchQuery')
  selectedCategories.value = objectByValueKeys(new Set(searchParams.get(CATEGORIES)?.split(',')), categories)
  selectedContentTypes.value = objectByValueKeys(new Set(searchParams.get(CONTENT_TYPE)?.split(',')), contentTypes)
}

window.addEventListener('popstate', () => {
  initFilterState()
})

initFilterState()

let filterChange = () => {

  const url = new URL(window.location);

  let categoriesSearch = [...filterChildren(categories, selectedCategories.value)].map(v => v[optionValueKey]).join(',')

  if (categoriesSearch) {
    url.searchParams.set(CATEGORIES, categoriesSearch)
  } else {
    url.searchParams.delete(CATEGORIES)
  }

  let contentTypeSearch = [...selectedContentTypes.value].map(v => v[optionValueKey]).join(',')

  if (contentTypeSearch) {
    url.searchParams.set(CONTENT_TYPE, contentTypeSearch)
  } else {
    url.searchParams.delete(CONTENT_TYPE)
  }

  if (contentTypeSearch || categoriesSearch || searchQuery.value) {
    url.searchParams.set('searchQuery', searchQuery.value || '')
    url.searchParams.set('language', props.sfModel['Language'])
    applyAdditionalFilters(url)
  } else {
    url.searchParams.delete('searchQuery')
  }

  if (url.searchParams.has('searchQuery')) {
    url.searchParams.set('indexCatalogue', props.sfModel['IndexCatalogue'])
  } else {
    url.searchParams.delete('indexCatalogue')
    url.searchParams.delete('searchQuery')
    url.searchParams.delete('language')
    url.searchParams.delete('orderBy')
    removeAdditionalFilters(url)
  }

  url.pathname = url.pathname.replace(sfUtil.sfPathnamePagingRegex, '')

  url.searchParams.delete('page')

  location.href = url.toString();

}

let applyAdditionalFilters = (url) => {
  if (!additionalFilters) return
  for (let k in additionalFilters) {
    url.searchParams.set(k, additionalFilters[k])
  }
}

let removeAdditionalFilters = (url) => {
  if (!additionalFilters) return
  for (let k in additionalFilters) {
    url.searchParams.delete(k)
  }
}


</script>
